import { CircleCheck, CircleOff, TriangleAlert } from 'lucide-react'
import type { HygieneStatus } from '@/api/types'

interface StatusIconProps {
  status: HygieneStatus
  message?: string | null
}

export function StatusIcon({ status, message }: StatusIconProps) {
  const label =
    status === 'ok'
      ? (message ?? 'No hygiene issues')
      : status === 'warning'
        ? (message ?? 'Hygiene warning')
        : (message ?? 'Hygiene issue')

  const className =
    status === 'ok'
      ? 'status-icon status-icon--ok'
      : status === 'warning'
        ? 'status-icon status-icon--warning'
        : 'status-icon status-icon--error'

  const Icon = status === 'ok' ? CircleCheck : TriangleAlert
  const hidden = status === 'ok' ? 'Clean' : status === 'warning' ? 'Warning' : 'Issue'

  return (
    <button
      type="button"
      className={className}
      title={label}
      aria-label={label}
      onClick={(event) => event.stopPropagation()}
    >
      <Icon size={16} strokeWidth={2} aria-hidden />
      <span className="visually-hidden">{hidden}</span>
    </button>
  )
}

export function LostIcon({ label = 'Lost' }: { label?: string }) {
  return (
    <span className="status-icon status-icon--muted" title={label}>
      <CircleOff size={16} strokeWidth={2} aria-hidden />
      <span className="visually-hidden">{label}</span>
    </span>
  )
}
